import {Box, CircularProgress} from '@mui/material';
export const LoadingPage = () => {
  return (
    <Box sx={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress thickness={5} size={100} disableShrink />
    </Box>
  );
};
